var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lrg-card-bordered"},[_c('div',{staticClass:"lrg-card-bordered__bg",class:[
      _setup.cutCorner,
      _vm.borderHoverColor && `lrg-card-bordered__bg--hover-${_vm.borderHoverColor}`,
      `lrg-card-bordered__bg--${_vm.borderColor}`,
      ,
    ]}),_vm._v(" "),_c('div',{staticClass:"lrg-card-bordered__content",class:_setup.cutCorner},[_c('div',{staticClass:"lrg-card-bordered__content-inner"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }